<template>
    <div class="msg-wrapper">
        <div class="msg-placeholder flex-center-hori">
            <img>
        </div>
        <div class="msg-content-box ai-msg-box">
            <div class="ai-msg">
                <!-- <MsgChatRespondLogic
                    :data="logicData"
                /> -->
                <div class="ai-msg-content">
                    <!--                    <div class="think" v-if="think && think.length > 0">-->
                    <!--                        <template v-for="(item, index) in think">-->
                    <!--                            <div class="step"  :key="index" :class="{line: item.label == '发现'}" v-if="item.label != '结果'">-->
                    <!--                                <img class="icon_think" src="@/theme/images/icons/icon_think.png" />-->
                    <!--                                <label class="step-label" v-if="item.label != '结果'">{{item.label}}{{Math.ceil((index + 1) / 3)}}：</label>-->
                    <!--                                <label class="step-label" v-else>结果：</label>-->
                    <!--                                <span v-html="item.label === '行动' ? setStep(item.value) : item.value"></span>-->
                    <!--                            </div>-->
                    <!--                        </template>-->
                    <!--                    </div>-->
                    <p class="final-answer" v-html="content"></p>
                </div>
                <div class="ai-msg-misc flex-center-hori">
                    <div class="misc-content"></div>
                    <div class="misc-control flex-center-hori">
                        <div class="stop-generating" v-if="!data.finished" @click="stopReceive()">
                            <img src="@/theme/images/icons/icon_cancel_outline.svg">停止输出
                        </div>
                        <div v-if="!data.nospeech" v-show="data.finished" class="play-control">
                            <el-tooltip class="item" effect="dark" :content="!speeking ? '播放' : '停止播放'" placement="top" :popper-class="isDark?'show-detail-tooltip show-detail-tooltip-dark':'show-detail-tooltip'">
                                <i v-if="!speeking" class="ecp-iconfont ecp-icon-circle-play" @click="speekTextFlush(data.content)" />
                                <i v-else class="ecp-iconfont ecp-icon-stop" @click="speekTextStop()" />
                            </el-tooltip>
                        </div>
                        <div v-if="!data.nospeech" v-show="data.finished" class="feedback-display">
                            <el-tooltip class="item" effect="dark" content="复制问答" placement="top" :popper-class="isDark?'show-detail-tooltip show-detail-tooltip-dark':'show-detail-tooltip'">
                                <i class="ecp-iconfont ecp-icon-copy" @click="copyAskAnswer(data.content)" />
                            </el-tooltip>
                        </div>
                        <div v-if="data.feedback === 1 || data.feedback === -1" v-show="data.finished" class="feedback-display">
                            <i v-if="data.feedback == 1" class="ecp-iconfont ecp-icon-good good" title="满意" />
                            <i v-if="data.feedback == -1" class="ecp-iconfont ecp-icon-bad bad" title="不满意" />
                        </div>
                        <div v-else v-show="data.finished" class="feedback-control">
                            <el-tooltip class="item" effect="dark" content="点赞" placement="top" :popper-class="isDark?'show-detail-tooltip show-detail-tooltip-dark':'show-detail-tooltip'">
                                <i class="ecp-iconfont ecp-icon-good" @click="sendFeedBack(data, 1)" />
                            </el-tooltip>
                            <el-tooltip class="item" effect="dark" content="抱歉，我们将继续改进" placement="top" :popper-class="isDark?'show-detail-tooltip show-detail-tooltip-dark':'show-detail-tooltip'">
                                <i class="ecp-iconfont ecp-icon-bad" @click="sendFeedBack(data, -1)" />
                            </el-tooltip>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="msg-placeholder">
        </div>
    </div>
</template>
<script>
import copyToClipboard from 'copy-to-clipboard';

import FeedBackMixin from '@/app/mixins/FeedBackMixin.js';
import SpeekTextMixin from '@/app/mixins/SpeekTextMixin.js';

import MsgChatRespondLogic from './MsgChatRespondLogic.vue';

export default {
    name: 'MsgChatRespond',
    mixins: [FeedBackMixin, SpeekTextMixin],
    props: ['data', 'askData'],
    inject: ['stopGenerating'],
    components: { MsgChatRespondLogic },
    data () {
        return {
            speeking: false,
            socket: null,
            think: [],
            content: '',
            targetKey: ''
        };
    },
    computed: {
        isDark () {
            return this.$store.state.appSettings.isDark;
        }
    },
    mounted () {
        this.initAsk();
        // 数字人说话
        this.$bus.$on('digital-human:speek-callback', () => {
            this.speeking = true;
        });

        // 数字人待机
        this.$bus.$on('digital-human:standby-callback', () => {
            this.speeking = false;
        });
    },
    methods: {
        setStep (value) {
            return value.replace(/Action Input:/g, '') + ' )';
        },
        // 初始化用到的添加一个回答
        initAsk () {
            this.think = this.data.think;
            this.content = this.data.content;
        },
        // 添加一个回答
        addAsk (params) {
            this.content = this.content + params;
        },
        // 停止接收
        stopReceive () {
            this.$bus.$emit('shop:thisWs');
            this.$emit('thinkSocketFinish', { think: this.think, content: this.content });
        },
        /**
         * 复制到剪贴板
         */
        copyToClipboard (text) {
            copyToClipboard(text);
            this.$message.success('内容已复制到剪贴板');
        },
        /**
         * 复制问答对
         */
        copyAskAnswer () {
            let str = '';
            if (this.askData) {
                str += '问：\n' + this.askData.content + '\n';
            }
            if (this.data) {
                str += '答：\n' + this.data.content + '\n';
            }
            copyToClipboard(str);
            this.$message.success('问答已复制到剪贴板');
        }
    }
};
</script>
<style scoped lang="scss">
.msg-placeholder img {
    content: var(--assistant-avatar);
}
.ai-msg {
    box-sizing: border-box;
    width: 100%;
    background: var(--msg-ai-bg);
    border-radius: 8px;
    padding: 14px 16px;

    .ai-msg-content {
        box-sizing: border-box;
        width: 100%;
        padding: 0 0 8px;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.85);
        line-height: 20px;
        overflow-wrap: break-word;
        .think {
            background: rgba(223, 230, 248, 0.25);
            border-radius: 4px;
            padding: 14px 16px;
            max-height: 140px;
            overflow: auto;
            .step {
                margin: 4px 0;
                color: var(--font-color);
                .step-label {
                    height: 20px;
                    font-size: 14px;
                    margin-left: 6px;
                    color: var(--font-color);
                    line-height: 20px;
                }
                .icon_think {
                    margin-top: -6px;
                    vertical-align: middle;
                    opacity: var(--msg-think-icon);
                }
            }
            .step {
                &.line {
                    border-bottom: 1px solid var(--msg-think-line);
                    padding-bottom: 10px;
                    margin-bottom: 10px;
                }
                &:last-child {
                    border-bottom: none;
                    padding-bottom: 0;
                    margin-bottom: 0;
                }
            }
            //.step:last-child{
            //    &.line{
            //        border-bottom: none;
            //        padding-bottom: 0;
            //        margin-bottom: 0;
            //    }
            //}
        }
        .final-answer {
            font-size: 16px;
            color: var(--font-color);
            line-height: 24px;
            white-space: break-spaces;
            margin-bottom: 0;
        }
    }

    .ai-msg-misc {
        box-sizing: border-box;
        width: 100%;
        border-top: 1px solid var(--shortcuts-border);
        padding-top: 12px;
        line-height: 22px;

        .misc-content {
            flex: 1 1 auto;
        }

        .stop-generating {
            font-size: 12px;
            color: #666;
            cursor: pointer;
            display: flex;
            align-items: center;
            img {
                vertical-align: bottom;
                height: 1em;
                cursor: pointer;
                margin: 0 2px;
            }
        }
        .misc-control {
            flex: 0 0 auto;

            img {
                height: 24px;
                cursor: pointer;
                margin: 0 2px;
            }

            i {
                margin: 0 2px;
                margin-top: 0;
                line-height: 22px;
            }
        }

        .play-control,
        .feedback-display,
        .feedback-control {
            flex: 0 0 auto;
            i {
                cursor: pointer;
                font-size: 20px;
                opacity: 0.5;
                &:hover {
                    opacity: 1;
                }
            }
        }

        .feedback-display {
            .good {
                cursor: unset;
                opacity: 1;
                color: #126CFF;
            }
            .bad {
                cursor: unset;
                opacity: 1;
                color: #ff1212;
            }
        }
    }
}

.ai-name-round {
    background: #ffffff;

    div {
        font-size: 16px;
        font-family: PingFang SC-Medium, PingFang SC, SourceHanSansSC-Medium, SourceHanSansSC, Microsoft Yahei;
        font-weight: 500;
        color: #f55212;
        line-height: 22px;
    }
}
</style>
